import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toApplicationReviewData = (data: unknown): ApplicationReviewWorkflowData => {
    return {
        verdict: get(data, 'verdict'),
        email: get(data, 'email'),
        workflow: toWorkflowData(data),
        workflowType: 'application-review',
        user: get(data, '_embedded.user'),
    }
}
